import { Types } from "index.js"

export enum AccessRightResult {
    Unknown,
    HasAccess,
    NoAccess
}

export class AccessCache {
    private _cache: Map<string, AccessRightResult> = new Map()
    private _keyCache: Map<Types.DocumentId, Types.Document[]> = new Map()

    constructor() {
    }

    markDocumentAsHavingAccess(documentId: string) {
        this._cache.set(documentId, AccessRightResult.HasAccess)
    }

    markDocumentAsHavingNoAccess(documentId: string) {
        this._cache.set(documentId, AccessRightResult.NoAccess)
    }

    checkAccess(documentId: string): AccessRightResult {
        return this._cache.get(documentId) ?? AccessRightResult.Unknown
    }

    isDocumentAccessAllowed(documentId: string): boolean {
        return this._cache.get(documentId) === AccessRightResult.HasAccess
    }

    isDocumentAccessDenied(documentId: string): boolean {
        const access = this._cache.get(documentId)
        return access === AccessRightResult.NoAccess
    }

    cacheKeysForLock(lockId: Types.DocumentId, keys: Types.Document[] | null) {
        this._keyCache.set(lockId, keys)
    }

    getCachedKeysForLock(lockId: Types.DocumentId): Types.Document[] | null | undefined {
        return this._keyCache.get(lockId)
    }
}